module.exports = {"id":"194761","name":"Borja García","rating":"77","photo":"./data/images/photos/4/194761.png","club":{"name":"Girona CF","logo":"./data/images/clubs/GironaCF.png"},"positions":["MC","BU","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BorjaGarcia0.json
// module id = 621
// module chunks = 0